"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSettlement = void 0;
const react_1 = require("react");
const SettlementContext_1 = require("./SettlementContext");
const useSettlement = () => {
    const context = (0, react_1.useContext)(SettlementContext_1.SettlementContext);
    if (!context)
        throw new Error('useSettlement must be used within a SettlementProvider');
    return context;
};
exports.useSettlement = useSettlement;
